import React from 'react';
import { ArrowRight } from 'lucide-react';
import { ROUTE_CONFIGS } from '../routes';
import { formatFromPrice } from '../priceDisplay.js';
import { formatDepartureArrivals } from '../routeTimes';

// Pure twin of homepage popular-route cards. PURITY: react, lucide-react, src/seo/*.

const DefaultLink = ({ href, className, children }) => (
  <a href={href} className={className}>
    {children}
  </a>
);

const PopularRouteCards = ({ LinkComponent = DefaultLink }) => {
  const Link = LinkComponent;

  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {ROUTE_CONFIGS.map((route) => (
        <Link
          key={route.slug}
          href={`/${route.slug}`}
          className="group relative overflow-hidden rounded-2xl border border-riverside-sand bg-white p-6 transition-colors hover:border-riverside-red"
        >
          <h3 className="font-serif text-lg font-bold text-riverside-dark">{route.breadcrumbLabel}</h3>
          {route.kind === 'bus' && route.departures?.length > 0 && (
            <p className="mt-1 text-sm text-riverside-muted">
              {/* Departure → arrival from GTFS (owner, 2026-10-23), so an assistant
                  reading the homepage gets arrival times without estimating. */}
              {formatDepartureArrivals(route) || route.departures.join(' & ')}
              {route.hotelPickupHint ? ` · ${route.hotelPickupHint}` : ''}
            </p>
          )}
          {route.duration && (
            <p className={`${route.kind === 'bus' && route.departures?.length ? 'mt-0.5' : 'mt-1'} text-sm text-riverside-muted`}>
              {route.duration}
            </p>
          )}
          <div className="mt-4 flex items-center justify-between">
            <span className="text-riverside-red font-semibold">
              {route.kind === 'private'
                ? 'Instant quote'
                : route.priceFromGbp != null
                  ? formatFromPrice(route.priceFromGbp)
                  : null}
            </span>
            <ArrowRight size={17} className="text-riverside-red transition-transform group-hover:translate-x-1" />
          </div>
        </Link>
      ))}
    </div>
  );
};

export default PopularRouteCards;
